// extracted by mini-css-extract-plugin
module.exports = {"jumbo":"_1KCA24K-ZT-button-size-jumbo-jumbo","circle":"qheasFKHuq-button-size-jumbo-circle","pill":"_1broJ3BBMy-button-size-jumbo-pill"};